import { store, getContext } from '@wordpress/interactivity';
import { decode } from 'he';

/**
 * Adds timeline-specific interactivity to the store.
 */
store('mediapress-live', {
  state: {
    get entryHrefAttr() {
      const context = getContext();
      return `#entry:${context?.entry?.id}`;
    },
    get title() {
      const context = getContext();
      return decode(context?.entry?.title.rendered || '');
    },
  },
  callbacks: {
    timelineItemClick: (e) => {
      e.preventDefault();
      const href = e.target.getAttribute('href');
      const id = href.replace('#entry:', '');
      const element = document.getElementById(`entry:${id}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
  },
});
